export default __webpack_public_path__ + "static/media/grocery.45856e7f.jpg";